import { render } from "./Sidebar.vue?vue&type=template&id=f3264644&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=f3264644&scoped=true&lang=css"

import exportComponent from "/builds/octoblue/narrowcastingrpi/narrowcastingwebapp/narrowcasting_vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3264644"]])

export default __exports__